import { ChatbotNode, ContinueType, NodeTypes, TextContentHighlightMod, TextContentType } from '@myriadgenetics/mgh-types';

import { NODE_IDS } from '../constants';
import { getNextComponentId } from '../../../../helpers/components';

export const outsideCriteriaTCUnderThresholdNode: ChatbotNode = {
  id: NODE_IDS.OUTSIDE_CRITERIA_TC_UNDER_THRESHOLD_NODE,
  name: 'Outside Criteria TC Under Threshold Node',
  type: NodeTypes.Chat,
  data: {
    continueType: ContinueType.End,
    pageTitleKey: 'pageTitles.chatbot.doesNotMeetResultsNode',
  },
  components: [
    {
      id: getNextComponentId(),
      type: 'TEXT_CONTENT',
      name: 'You are not a candidate',
      description: 'You are not a candidate',
      data: {
        contentKey: 'chatbot.outsideCriteriaResults.notCandidate',
        inlineImages: [
          {
            src: 'chatbot.outsideCriteriaResults.minusImg.src',
            altKey: 'chatbot.outsideCriteriaResults.minusImg.alt',
          },
          {
            src: 'chatbot.outsideCriteriaResults.notCandidateImage.src',
            altKey: 'chatbot.outsideCriteriaResults.notCandidateImage.alt',
          },
        ],
        type: TextContentType.Text1,
        highlightModifier: TextContentHighlightMod.Primary,
        delay: 3500,
        avatarSvg: 'chatbot.hcpAvatar',
      },
    },
    {
      id: getNextComponentId(),
      type: 'TEXT_CONTENT',
      name: 'This Assessment does not take all criteria into consideration',
      data: {
        contentKey: 'chatbot.outsideCriteriaResults.importanceOfTest',
        type: TextContentType.Text1,
        highlightModifier: TextContentHighlightMod.Primary,
        delay: 3500,
        avatarSvg: 'chatbot.hcpAvatar',
      },
    },
    {
      id: getNextComponentId(),
      type: 'TEXT_CONTENT',
      name: 'Thank you',
      description: 'Thank you',
      data: {
        contentKey: 'chatbot.thankYou.finishAssessment',
        inlineImages: [
          {
            src: 'chatbot.thankYou.checkImg.src',
            altKey: 'chatbot.thankYou.checkImg.alt',
          },
          {
            src: 'chatbot.thankYou.thankYouImage.src',
            altKey: 'chatbot.thankYou.thankYouImage.alt',
          },
        ],
        type: TextContentType.Text1,
        highlightModifier: TextContentHighlightMod.Primary,
        delay: 3500,
        avatarSvg: 'chatbot.hcpAvatar',
      },
    },
    {
      id: getNextComponentId(),
      type: 'TEXT_CONTENT',
      name: 'Close browser',
      description: 'Close browser',
      data: {
        contentKey: 'chatbot.closePage',
        type: TextContentType.Text1,
        highlightModifier: TextContentHighlightMod.Primary,
        delay: 3500,
        avatarSvg: 'chatbot.hcpAvatar',
      },
    },
  ],
};

export default outsideCriteriaTCUnderThresholdNode;
